import React from 'react';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import LanguageRoundedIcon from '@material-ui/icons/LanguageRounded';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

function LanguageSelector({
  languages, selectedLanguageId, onSelect, style,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = lang => () => {
    onSelect(lang);
    handleClose();
  };

  const menuItems = () => languages.map(lang => (
    <MenuItem
      style={{ color: '#6c757d', paddingRight: '80px' }}
      key={lang.id}
      selected={lang.id === selectedLanguageId}
      onClick={handleSelect(lang.id)}>
        {lang.name}
      </MenuItem>
  ));

  const currentSelectedName = () => {
    const selectedLang = languages.find(e => e.id === selectedLanguageId);
    return selectedLang ? selectedLang.name : languages[0].name;
  };

  return (
    <div style={style}>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        style={{ color: '#6c757d', textTransform: 'none', fontWeight: '400' }}
        startIcon={<LanguageRoundedIcon />}
        endIcon={<ExpandMoreIcon />}
      >
        {currentSelectedName()}
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        variant="menu"
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {menuItems()}
      </Menu>
    </div>
  );
}

export default LanguageSelector;
